import React from "react";
import MaestroLoader from "@components/MaestroLoader";
import ErrorLoadingWidget from "./ErrorLoadingWidget";
import { LoadingWidget } from "./LoadingWidget";
import { Box, Button, CardCover, Grid, Typography } from "@mui/joy";
import pluralize from 'pluralize';
import CardWidget from "./layouts/CardWidget";
import { Calendar, dateFnsLocalizer } from "react-big-calendar";
import format from "date-fns/format";
import parse from "date-fns/parse";
import startOfWeek from "date-fns/startOfWeek";
import getDay from "date-fns/getDay";
import enUS from "date-fns/locale/en-US";
import "react-big-calendar/lib/css/react-big-calendar.css";

const locales = {
    'en-US': enUS,
};

const localizer = dateFnsLocalizer({
    format,
    parse,
    startOfWeek,
    getDay,
    locales,
});


export default function CalendarWidget(props) {
    // TODO: build out endpoint for getting user's calendar events
    return (
        <CardWidget {...props}>
            <Calendar
                localizer={localizer}
                events={[]}
                startAccessor="start"
                endAccessor="end"
                style={{ width: '100%', height: '100%' }}
            />
        </CardWidget>
    );
}
